const NotificationType = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

Object.freeze(NotificationType);

export default NotificationType;
